function distance(a: string, b: string): number {
  const row = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    let prev = row[0] ?? 0;
    row[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const tmp = row[j] ?? 0;
      row[j] = Math.min(
        (row[j] ?? 0) + 1,
        (row[j - 1] ?? 0) + 1,
        prev + (a[i - 1] === b[j - 1] ? 0 : 1)
      );
      prev = tmp;
    }
  }
  return row[b.length] ?? 0;
}

/** Closest candidates to `input`, best first, within a small edit distance. */
export function suggest(
  input: string,
  candidates: string[],
  limit = 3
): string[] {
  const max = input.length <= 3 ? 1 : 2;
  return candidates
    .map(c => ({ c, d: distance(input, c) }))
    .filter(x => x.d <= max || (input.length >= 2 && x.c.startsWith(input)))
    .sort((a, b) => a.d - b.d || a.c.length - b.c.length)
    .slice(0, limit)
    .map(x => x.c);
}
